export const lang = {
	PRICE: 'Price',
	TOTAL: 'Total',
	PAYMENT_DATE: 'Payment Date',
	END_DATE: 'Your plan lasts until',
	NEXT_PAYMENT_DATE: 'Your next payment is due',
	WHEN_REDEEMED: 'when the gift is redeemed'
};
